import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=87fea0b6&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Upload.vue?vue&type=style&index=1&id=87fea0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fea0b6",
  null
  
)

export default component.exports